import axios from "axios"
import {
	ADMIN_LOGIN_FAIL,
	ADMIN_LOGIN_REQUEST,
	ADMIN_LOGIN_SUCCESS,
	ADMIN_LOGOUT,
	GET_ALL_ADMIN_FAIL,
	GET_ALL_ADMIN_REQUEST,
	GET_ALL_ADMIN_SUCCESS,
	GET_ADMIN_DATA_FAIL,
	GET_ADMIN_DATA_REQUEST,
	GET_ADMIN_DATA_SUCCESS,
} from "../constants/adminConstants"

export const getAllAdmins =
	() => async (dispatch) => {
		try {
			dispatch({ type: GET_ALL_ADMIN_REQUEST })
			const { data } = await axios.get(
				"/api/admin/all",
			)

			dispatch({
				type: GET_ALL_ADMIN_SUCCESS,
				payload: data,
			})
		} catch (error) {
			dispatch({
				type: GET_ALL_ADMIN_FAIL,
				payload:
					error.response &&
					error.response.data.message
						? error.response.data.message
						: error.message,
			})
		}
	}

export const loginAdmin =
	(email, password) => async (dispatch) => {
		try {
			const config = {
				headers: {
					"Content-Type": "application/json",
				},
			}
			dispatch({ type: ADMIN_LOGIN_REQUEST })
			const { data } = await axios.post(
				"/api/admin/login",
				{ email, password },
				config,
			)

			dispatch({
				type: ADMIN_LOGIN_SUCCESS,
				payload: data,
			})
			localStorage.setItem(
				"adminLogin",
				JSON.stringify(data),
			)
		} catch (error) {
			const status = error.response?.status
			let message

			if (status && status < 500 && error.response?.data?.message) {
				// Expected client-facing errors (wrong email/password) —
				// the backend's message is written for the user.
				message = error.response.data.message
			} else if (status) {
				// Server-side failure (DB down, unhandled crash, etc.) —
				// don't leak raw technical/internal error text to the user.
				message =
					"Something went wrong on our end. Please try again in a moment."
			} else {
				// Request never got a response (network down, server unreachable).
				message =
					"Unable to reach the server. Please check your connection and try again."
			}

			dispatch({
				type: ADMIN_LOGIN_FAIL,
				payload: message,
			})
		}
	}

export const getAdminData =
	() => async (dispatch, getState) => {
		try {
			const {
				adminLogin: { admin },
			} = getState()

			const config = {
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${admin.token}`,
				},
			}

			dispatch({ type: GET_ADMIN_DATA_REQUEST })

			const { data } = await axios.post(
				"/api/admin/getadmin",
				{},
				config,
			)

			dispatch({
				type: GET_ADMIN_DATA_SUCCESS,
				payload: data,
			})
		} catch (error) {
			dispatch({
				type: GET_ADMIN_DATA_FAIL,
				payload:
					error.response &&
					error.response.data.message
						? error.response.data.message
						: error.message,
			})
			// Token is invalid/expired — drop it so the user isn't stuck
			// bounced between a protected page and the login screen.
			localStorage.removeItem("adminLogin")
			dispatch({ type: ADMIN_LOGOUT })
		}
	}

export const logoutAdmin = () => (dispatch) => {
	localStorage.removeItem("adminLogin")
	dispatch({ type: ADMIN_LOGOUT })
}
